export const SET_BANNERS = 'ROOM/BANNERS/SET_BANNERS'
